import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M7.61 3.958H5.258c-.607 0-1.098.492-1.098 1.099 0 6.067 4.918 10.985 10.984 10.985.607 0 1.099-.492 1.099-1.099V12.59l-2.59-1.726-1.342 1.343a.749.749 0 0 1-.875.154 9.244 9.244 0 0 1-2.098-1.497 7.272 7.272 0 0 1-1.53-2.118c-.134-.284-.056-.61.165-.833l1.365-1.364-1.726-2.59Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);